import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc.js'
import type { RentalOrder } from '@super-mega/server/contracts/order'

dayjs.extend(utc)

export function formatDate(value: Date) {
  return dayjs.utc(value).format('YYYY-MM-DD')
}

export function getPropertyAddress(snapshot: unknown, roomNo: string | null) {
  const address =
    snapshot && typeof snapshot === 'object' && !Array.isArray(snapshot) ? (snapshot as Record<string, unknown>) : {}
  return (
    [...['provinceName', 'cityName', 'districtName', 'detailAddress'].map((key) => address[key]), roomNo]
      .filter((value): value is string => typeof value === 'string' && Boolean(value.trim()))
      .join(' ') || '未记录详细地址'
  )
}

export function getSubjectLabel(order: RentalOrder) {
  return (
    (order.subjectSnapshot
      ? [order.subjectSnapshot.company?.name, order.subjectSnapshot.identity?.name].filter(Boolean).join(' / ') ||
        order.subjectSnapshot.subject?.displayName
      : [order.companyName, order.identityName].filter(Boolean).join(' / ') || order.subjectName) || '未关联'
  )
}
